import { Box } from "@mui/material";
import { isIosPlatform } from "@src/appV2/lib/utils/capacitor/platformUtils";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import {
  BottomSheetIllustrationContent,
  BottomSheetLoadingContent,
  Title,
} from "@src/appV2/redesign/system/ui-components";

interface ScannerProps {
  onScanCancelled: () => void;
}

export function Scanner(props: ScannerProps) {
  const { onScanCancelled } = props;

  // For iOS, show a loading bottom sheet with scanning status
  // since the native NFC dialog is shown instead, which controls the cancellation of the scan
  // This appears briefly during active scanning and momentarily when user cancels
  if (isIosPlatform()) {
    return (
      <BottomSheetLoadingContent title="Scanning NFC poster" description="Scan in progress..." />
    );
  }

  return (
    <>
      <BottomSheetIllustrationContent
        illustrationType="nfc-poster-animated"
        title={
          <Title variant="h3" component="h1">
            Ready to scan
          </Title>
        }
        description={
          <Box sx={(theme) => ({ px: theme.spacing(9) })}>Hold near NFC tag to scan</Box>
        }
      />

      <DialogFooter
        orientation="vertical"
        closeButtonAriaLabel="Cancel"
        onClose={onScanCancelled}
      />
    </>
  );
}
